import { ReactNode, FormEvent } from "react"
import { BaseComponent, BaseProps, BaseState } from "../BaseComponent"
import { BaseEnumType } from "../../initialization/remoteInits"
import { isEmpty } from "../../validation/stringRegex"

interface SelectProps extends BaseProps {
    options?: any | undefined,
    value: string | undefined,
    forceSortById?: boolean
    forceReverseSortById?: boolean
    forceSortByLabel?: boolean
}

interface SelectStatus extends BaseState {
    hasFocus: boolean
    forceRedraw: boolean
}

const defaults : SelectProps = {
    id: undefined,
    options: undefined,
    value: undefined,
    callback: undefined,
    error: undefined,
    errorDisplayMsg: undefined
}

type SelectEnumType = {[k: string]: string}

class Select extends BaseComponent<SelectProps, SelectStatus> {

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props} as SelectProps

        this.state = {
            hasFocus: false,
            forceRedraw: false
        }

        this.getSelected = this.getSelected.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handlerCallBack = this.handlerCallBack.bind(this)
    }


    render(): ReactNode {
        const stringValue = this.props.value ?? ''

        const classString = 
            (this.state.hasFocus ? 'focus ' : '') +
            (this.notEmpty(this.props.value) ? 'is-ok ' : '') +

            ((this.props.error ?? this.state?.validationError !== undefined) ? 'is-invalid ' : '') +

            ((this.props.className ?? '') === 'form-select-lg form-control' 
                ? this.props.className + ' form-select-lg form-control'
                : 'form-select-lg form-control' 
            )

        const labelTag = super.getSelectionLabel()

        let options: SelectEnumType = {}

        if (
            this.props.options !== undefined && 
            Object.prototype.toString.call(this.props.options) === '[object Array]'
        ) {
            // trasformo da array a oggetto
            (this.props.options as Array<BaseEnumType>).forEach( o => {
                const pr_id: string = o.id
                const pr_val: string = o.value

                options[pr_id] = pr_val
            })
        } 
        else {
            options = this.props.options
        }

        let entries = undefined

        if (options) {
            entries = Object.entries(options)

            // se richiesto riordino
            if (this.props.forceSortById === true) {
                // in base al ID / valore
                entries = entries.sort(
                    (a,b) => {
                        return (Number(a[0]) > Number(b[0])) ? 1 : -1
                    }
                )
            }
            else if (this.props.forceReverseSortById === true) {
                // in base al ID / valore dal maggiore al minore
                entries = entries.sort(
                    (a,b) => {
                        return (Number(a[0]) < Number(b[0])) ? 1 : -1
                    }
                )
            }
            else if (this.props.forceSortByLabel === true) {
                // in base alla label
                entries = entries.sort(
                    (a,b) => {
                        return (Number(a[1]) > Number(b[1])) ? 1 : -1
                    }
                )
            }
        }


        /*
            ad esempio
            this.props.options = {} || {"casalinga": "Casalinga", ..}
        */
        return (
            (this.props.id) &&
            <>
                {labelTag !== undefined && labelTag}
                <select 
                    id={this.props.id}
                    className={classString}
                    name={this.props.name}
                    onChange={this.onChange}
                    onFocus={this.props.onFocus}
                    value={ stringValue }
                >
                    {/* selected={this.props.value === undefined} */}
                    <option 
                        value={''} key={'undefined_' + this.props.id}
                    >
                        Seleziona
                    </option>
                    {
                        entries &&
                            entries.map( ([k,v]) => {
                                const key: string = k
                                // forzo a string - indipendentemente dal tipo reale
                                const val: string = v as string

                                return (
                                    <option 
                                        key={key} 
                                        value={key}
                                    >
                                        {val}
                                    </option>
                                )
                            })
                    }
                </select>
            </>
        )
    }

    private getSelected (val: string) {
        return this.props.value === val
    }

    private onChange (e: FormEvent<HTMLSelectElement>) {
        e.preventDefault()

        this.handlerCallBack(
            isEmpty(e.currentTarget.value)
                ? undefined
                : e.currentTarget.value
        )
    }

    private handlerCallBack (value: any) {
        if (this.props.callback) {
            this.props.callback (
                isEmpty(value)
                    ? undefined
                    : value
            )
        }
    }

}

export default Select